import React from 'react'
import PropTypes from 'prop-types'

import AttachmentsList from 'components/AttachmentsList'

import styles from './styles'

function RestrictiveListAnswer(props) {
  const { questionData } = props
  const answers = questionData?.answer?.answer_object
  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Lista restritiva - {questionData.occurrence.list_name}</h2>
      <div className={classes.formWrapper}>
        <h3>Pergunta:</h3>
        <p>{questionData.text}</p>

        {answers && (
          <React.Fragment>
            <h3>Resposta:</h3>
            <div className={classes.subject}>
              <p>
                <span>Fatos envolvidos na inclusão em lista restritiva: </span>{' '}
                {answers.facts_about_inclusion}
              </p>
              <p>
                <span>Breve relato sobre o ocorrido: </span>{' '}
                {answers.occurrence_summary}
              </p>

              <p>
                <span>Tratativas adotadas para a situação: </span>
                {answers.adopted_approaches}
              </p>

              {answers.attachments.length > 0 ? (
                <AttachmentsList
                  expanded
                  attachments={answers.attachments}
                  title="Anexos do resumo da ocorrencia e/ou processos administrativos"
                />
              ) : null}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

RestrictiveListAnswer.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default RestrictiveListAnswer
